<div mat-dialog-title class="mobile_interface_title">
    <div class="mobile_interface_title_in" style="overflow: hidden;">
        <div class="tab_title" (click)="close()">
            <div class="d-f-c">
                <div class="icon_back">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7 12L6.11612 11.1161C5.62796 11.6043 5.62796 12.3957 6.11612 12.8839L7 12ZM16.8839 3.88388C17.372 3.39573 17.372 2.60427 16.8839 2.11612C16.3957 1.62796 15.6043 1.62796 15.1161 2.11612L16.8839 3.88388ZM15.1161 21.8839C15.6043 22.372 16.3957 22.372 16.8839 21.8839C17.372 21.3957 17.372 20.6043 16.8839 20.1161L15.1161 21.8839ZM7.88388 12.8839L16.8839 3.88388L15.1161 2.11612L6.11612 11.1161L7.88388 12.8839ZM6.11612 12.8839L15.1161 21.8839L16.8839 20.1161L7.88388 11.1161L6.11612 12.8839Z" fill="#232323"/>
                    </svg>
                </div>
                <span>
                    {{ "Date" | translate }}
                </span>
            </div>
        </div>
    </div>
</div>
<mat-dialog-content class="mobile_interface_content">
    <div class="mobile_scrollable_int_big" style="background: #fff;">
        <section class="sub_filter_wrp">
            <div class="subs" [appDeviceClass]="'custom-scroll'">
                <div class="sub" *ngFor="let tab of data.datesModel" [ngClass]="{'active': data.datesControl.value === tab.id}" (click)="patchControl(data.datesControl, tab.id)">
                    {{ tab.name | translate }} <ng-container *ngIf="tab?.onlyThis">*</ng-container>
                </div>
            </div>
            <div class="block">
                <div class="sub_tabs">
                    <div class="sub_tabs_in">
                        <div class="sub_tab" *ngFor="let subTab of data.datesModel[data.datesControl.value].filters" [ngClass]="{'active': data.datesModel[data.datesControl.value].activeFilter.value === subTab.id}" (click)="data.datesModel[data.datesControl.value].filters.length > 1 ? patchControl(data.datesModel[data.datesControl.value].activeFilter, subTab.id) : null;">
                            {{subTab.name}} <ng-container *ngIf="subTab?.onlyThis">*</ng-container>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="!switched">
                    <form [formGroup]="data.filter" class="exp_form" [appDeviceClass]="'custom-scroll'">
                        <mat-calendar (selectedChange)="rangeChange($event, data.datesModel[data.datesControl.value].filters[data.datesModel[data.datesControl.value].activeFilter.value].key)" [selected]="data.datesModel[data.datesControl.value].filters[data.datesModel[data.datesControl.value].activeFilter.value].range"></mat-calendar>
                        <div class="calendar_inputs">
                            <mat-form-field appearance="standard">
                                <mat-label>{{ "Date Start" | translate }}</mat-label>
                                <input matInput [matDatepicker]="dp_from" formControlName="{{data.datesModel[data.datesControl.value].filters[data.datesModel[data.datesControl.value].activeFilter.value].from}}">
                                <!-- <mat-datepicker-toggle matIconSuffix [for]="dp_from"></mat-datepicker-toggle> -->
                                <mat-datepicker #dp_from></mat-datepicker>
                            </mat-form-field>
                            <mat-form-field appearance="standard">
                                <mat-label>
                                    <ng-container *ngIf="!data.filter.get(data.datesModel[data.datesControl.value].filters[data.datesModel[data.datesControl.value].activeFilter.value].to).value && !!data.filter.get(data.datesModel[data.datesControl.value].filters[data.datesModel[data.datesControl.value].activeFilter.value].from).value; else elseTemplateSOFAR">
                                        {{ "So far" | translate }}
                                    </ng-container>
                                    <ng-template #elseTemplateSOFAR>
                                        {{ "Date End" | translate }}
                                    </ng-template>
                                </mat-label>
                                <input matInput [matDatepicker]="dp_to" formControlName="{{data.datesModel[data.datesControl.value].filters[data.datesModel[data.datesControl.value].activeFilter.value].to}}">
                                <!-- <mat-datepicker-toggle matIconSuffix [for]="dp_to"></mat-datepicker-toggle> -->
                                <mat-datepicker #dp_to></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </form>
                </ng-container>
            </div>
        </section>
    </div>
</mat-dialog-content>
<mat-dialog-actions>
    <div class="mobile_interface_buttons small_mob_btns" style="justify-content: space-between !important;">
        <button class="mobile_interface_btn" (click)="close()">
            {{ "Cancel" | translate }}
        </button>

        <button class="mobile_interface_btn mobile_interface_btn_white" (click)="clearDate(data.datesModel[data.datesControl.value].filters[data.datesModel[data.datesControl.value].activeFilter.value].key)">
            {{ "Clear" | translate }}
        </button>

        <button class="mobile_interface_btn mobile_interface_btn_blue" (click)="onSubmit()">
            {{ "Apply" | translate }}
        </button>
    </div>
</mat-dialog-actions>